module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/map-marker.svg?6f95c207b84a6931841d431e4c8a55ff";